import { action } from 'mobx';
import { User } from './user';
import { AppStore } from './AppStore';
import PixelAppForm from './pixelAppForm';
import AdGroupBudget from './adGroupBudget';
import AdSetBudgetBid from './adSetBudgetBid';
import ArticleGroupForm from './articleGroupForm';
import { createContext, useContext } from 'react';
import ArticleBudgetCap from './ArticleBudgetCap';
import { EditArticleStore } from './EditArticleStore';
import AlertAcknowledgeForm from './alertAcknowledgeForm';
import { EditPublisherStore } from './EditPublisherStore';
import { RetroDiscountsStore } from './retroDiscountsStore';
import { AudienceManagerStore } from './AudienceManagerStore';
import { TextAssetsBuilderStore } from './TextAssetsBuilderStore';
import { CreativeTemplatePreviews } from './creativeTemplatePreviews';
import { GoogleAssetsTextsStore } from './GoogleAssets/GoogleAssetsTextsStore';
import { CreativeTemplatesBuilderStore } from './CreativeTemplatesBuilderStore';
import { GoogleAssetsImagesStore } from './GoogleAssets/GoogleAssetsImagesStore';
import { GoogleAssetsBuilderStore } from './GoogleAssets/GoogleAssetsBuilderStore';
import { RulesStore } from './pages/Rules/RulesStore';

class RootStore {
  app: AppStore;
  articleGroupForm: ArticleGroupForm;
  creativeTemplatePreviews: CreativeTemplatePreviews;
  pixelAppForm: PixelAppForm;
  alertAcknowledgeForm: AlertAcknowledgeForm;
  user: User;
  updateBudget: AdSetBudgetBid;
  updateGoogleBudget: AdGroupBudget;
  updateArticleBudgetCapStore: ArticleBudgetCap;
  creativeTemplatesBuilderStore: CreativeTemplatesBuilderStore;
  editArticleStore: EditArticleStore;
  rulesStore: RulesStore;
  editPublisherStore: EditPublisherStore;
  textAssetsBuilderStore: TextAssetsBuilderStore;
  audienceBuilderStore: AudienceManagerStore;
  googleAssetsBuilderStore: GoogleAssetsBuilderStore;
  googleAssetsImagesStore: GoogleAssetsImagesStore;
  googleAssetsTextsStore: GoogleAssetsTextsStore;
  retroDiscountsStore: RetroDiscountsStore;

  constructor() {
    this.app = new AppStore(this);
    this.articleGroupForm = new ArticleGroupForm();
    this.creativeTemplatePreviews = new CreativeTemplatePreviews();
    this.pixelAppForm = new PixelAppForm();
    this.user = new User(this);
    this.alertAcknowledgeForm = new AlertAcknowledgeForm();
    this.updateBudget = new AdSetBudgetBid();
    this.updateGoogleBudget = new AdGroupBudget();
    this.updateArticleBudgetCapStore = new ArticleBudgetCap();
    this.creativeTemplatesBuilderStore = new CreativeTemplatesBuilderStore();
    this.editArticleStore = new EditArticleStore();
    this.rulesStore = new RulesStore();
    this.editPublisherStore = new EditPublisherStore();
    this.textAssetsBuilderStore = new TextAssetsBuilderStore();
    this.audienceBuilderStore = new AudienceManagerStore();
    this.googleAssetsBuilderStore = new GoogleAssetsBuilderStore();
    this.googleAssetsImagesStore = new GoogleAssetsImagesStore();
    this.googleAssetsTextsStore = new GoogleAssetsTextsStore();
    this.retroDiscountsStore = new RetroDiscountsStore();
  }

  @action resetCreativeTemplatesBuilderStore = () => {
    this.creativeTemplatesBuilderStore = new CreativeTemplatesBuilderStore();
    this.textAssetsBuilderStore = new TextAssetsBuilderStore();
  };

  @action resetGoogleAssetsBuilderStore = () => {
    this.googleAssetsBuilderStore = new GoogleAssetsBuilderStore();
    this.googleAssetsImagesStore = new GoogleAssetsImagesStore();
    this.googleAssetsTextsStore = new GoogleAssetsTextsStore();
  };
}

export const RootStoreContext = createContext<RootStore | undefined>(undefined);

export const useRootStore = () => {
  const store = useContext(RootStoreContext);
  if (!store) {
    throw new Error('Root store is used outside of its context');
  }
  return store;
};

export default RootStore;
